import { RouteRecordRaw } from 'vue-router'
import { middleware } from '@/helpers/auth'

const authRoutes: Array<RouteRecordRaw> = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/LoginView.vue'),
    beforeEnter: [middleware.isGuest]
  },
  {
    path: '/login/register',
    name: 'login-register',
    component: () => import('@/views/login/RegisterView.vue'),
    beforeEnter: [middleware.isGuest]
  },
  {
    path: '/login/restore',
    name: 'login-restore',
    component: () => import('@/views/login/RestoreView.vue'),
    beforeEnter: [middleware.isGuest]
  },
  {
    path: '/login/restore-success',
    name: 'login-restore-success',
    component: () => import('@/views/login/ResetSuccessView.vue'),
    beforeEnter: [middleware.isGuest]
  },
  {
    path: '/login/success',
    name: 'login-success',
    component: () => import('@/views/login/LoginSuccessView.vue'),
    beforeEnter: [middleware.isAuth]
  }
]

export default authRoutes
